import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'app-ds-card-body',
  templateUrl: './ds-card-body.component.html',
  styleUrls: ['./ds-card-body.component.scss']
})
export class DsCardBodyComponent {
  @HostBinding('class.ds-card__body') readonly hostClass = true;
}
